import React, { useEffect, useState } from "react";

import { redirectToLogin } from "@/lib/utils";
import useGlobalStore from "@/stores/useGlobalStore";
import { BUSINESS_CONFIG } from "@/constants/businessConfig";

import { Button } from "./ui/button";
import BusinessHeader from "./BusinessHeader";

const AccessDenied = ({ message, redirectUrl }) => {
  const [show, setShow] = useState(false);
  const { business } = useGlobalStore();

  useEffect(() => {
    // Add entrance animation after component mounts
    const timer = setTimeout(() => setShow(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Business Header Component */}
      <BusinessHeader />

      {/* Content */}
      <div className="flex-1 flex flex-col items-center px-4 mt-20">
        <div className={`w-full max-w-md p-8 space-y-8 rounded-xl transition-all duration-500 ${show ? "opacity-100 transform translate-y-0" : "opacity-0 transform -translate-y-4"}`}>
          <div className="text-center">
            <div className="relative mx-auto w-24 h-24 mb-6">
              {/* Lock icon with circle background and pulsing animation */}
              <div className={`absolute inset-0 bg-red-100 rounded-full flex items-center justify-center transition-all duration-500 ${show ? "animate-pulse" : ""}`}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
            </div>

            <h1 className={`text-2xl font-bold text-gray-900 mb-2 transition-all duration-500 delay-100 ${show ? "opacity-100 transform translate-y-0" : "opacity-0 transform -translate-y-4"}`}>
              Truy cập bị từ chối
            </h1>

            <p className={`text-gray-600 mb-6 transition-all duration-500 delay-200 ${show ? "opacity-100 transform translate-y-0" : "opacity-0 transform -translate-y-4"}`}>
              {message || "Bạn không có quyền truy cập vào trang này. Vui lòng liên hệ quản trị viên để được hỗ trợ."}
            </p>

            <div className={`flex flex-col space-y-3 transition-all duration-500 delay-300 ${show ? "opacity-100 transform translate-y-0" : "opacity-0 transform -translate-y-4"}`}>
              <Button onClick={redirectToLogin} className="w-full" variant="default">
                Đăng nhập tài khoản khác
              </Button>
            </div>
          </div>
        </div>

        {/* <p className={`mt-8 text-sm text-gray-500 transition-all duration-500 delay-400 ${show ? "opacity-100" : "opacity-0"}`}>
          Nếu bạn cho rằng đây là lỗi, vui lòng liên hệ{" "}
          <a href="mailto:support@kido.vn" className="text-blue-600 hover:underline">
            support@kido.vn
          </a>
        </p> */}
      </div>
    </div>
  );
};

export default AccessDenied;
